import React from "react";
import {
  Dialog,
  List,
  ListItem,
  DialogTitle,
  Avatar,
  CircularProgress,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  Popover,
  Divider
} from "@mui/material";
import { Person } from "@mui/icons-material";

const Notification = ({
  isLoading,
  FetchNotifications,
  notifications,
  open,
  onClose,
}) => {
  return (
    <Popover
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      sx={{marginTop:"4rem", width: "95%", marginRight: "4rem"}}
      onClose={onClose}
      open={open}
      // maxWidth={"xs"}
      // sx={{ left: 0 }}
    >
      <DialogTitle>Notifications</DialogTitle>
      <Divider style={{backgroundColor: "rgb(0,0,0,0.5)"}} />
      <List sx={{ pt: 0 }}>
        {notifications &&
          notifications?.map((item) => (
            <ListItem disableGutters key={item.id}>
              <ListItemButton>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "blue", color: "white" }}>
                    <Person />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={item?.message} />
              </ListItemButton>
            </ListItem>
          ))}
        {!isLoading && notifications?.length < 1 && (
          <div className="noNotification" >No Notifications Currently</div>
        )}
        {isLoading && (
          <div className="Spinner_Div">
            <CircularProgress color="inherit" size={20} />
          </div>
        )}
      </List>
    </Popover>
  );
};

export default Notification;
